import templateUrl from './inactive-form.html';

export const inactiveForm = {
  templateUrl,

  bindings: {
    formInfo: '<' // Les infos du formulaire de changement d'identifiants.
  }
};
